module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACRSURBVHgBjdJREYAgDAbgnQmIYAQbaBQbSAOIYANtQgQjEIEIczvHyQsb/x2Hd363YwMAJYg400q8gwEf/JI0dArK3Yr0IwoqGvL4Z+2hpUEHKB1mQWEEXaB0WMfAu+shewyUiVaRbwdWqNI9UnX8nALdUOeCZ7k2TrRwezvewnuDNwsH8wU1uI4tgRWeAFd8AcvVAs/R8YKWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_back_arrow.png
// module id = bady
// module chunks = 1